import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionManagerService, User } from '@ops/shared-types';
import { Subscription } from 'rxjs';

@Component({
  selector: 'top-logo-bar',
  templateUrl: './top-logo-bar.component.html',
  styleUrls: ['./top-logo-bar.component.scss'],
})
export class TopLogoBarComponent implements OnInit, OnDestroy {
  userInitials: string;
  uSub: Subscription;
  uAuthorized = false;

  constructor(
    private router: Router,
    private sessionManager: SessionManagerService
  ) {}

  ngOnDestroy(): void {
    this.uSub?.unsubscribe();
  }

  ngOnInit(): void {
    // let user = this.sessionManager.getUser();
    //this.userInitials = user.firstName[0]?.toUpperCase() + user.lastName[0]?.toUpperCase();
    this.uSub = this.sessionManager
      .getUserObservable()
      .subscribe((user: User) => {
        if (user?.accessToken) {
          this.uAuthorized = true;
        } else {
          this.uAuthorized = false;
        }
      });
  }

  get unAuthorized(): boolean {
    return this.uAuthorized === false;
  }

  onReturnToDashboard() {
    if (
      this.router.url.includes('login') ||
      this.router.url.includes('welcome') ||
      this.router.url.includes('verify') ||
      this.router.url.includes('/subscription') ||
      this.router.url.includes('stripe')
    ) {
      return;
    }
    this.router.navigate(['dashboard']);
  }
}
